import _ from 'lodash'
import Vue from 'vue'
import I18n from '@/services/i18n/i18n'

const i18n = I18n.getInstance()

export function validateEmail (email) {
  const emailRegex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm
  return emailRegex.test(email)
}

export function delegate (object, attributes) {
  return _.reduce(attributes, (acc, key, value) => {
    acc[key] = function () { return this[object] && this[object][key] }
    return acc
  }, {})
}

export function downloadFile (urls) {
  let url
  if (typeof urls === 'string') {
    url = urls
  } else if (urls.length) {
    url = urls[0]
  } else {
    return false
  }

  const fileName = url.split('/').pop()
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.dispatchEvent(new window.MouseEvent('click'))
  return true
}

export function setterFor (key) {
  return _.camelCase(`set-${key}`)
}

export function mapValueProps (properties, setter) {
  let props = {}
  properties.forEach((prop) => {
    props[prop] = {
      get () {
        return this.value && this.value[prop]
      },
      set (newValue) {
        if (setter == null) {
          this.$emit('input', {
            ...this.value,
            [prop]: newValue
          })
        } else {
          setter(prop, newValue, this)
        }
      }
    }
  })
  return props
}

export function mapStoreProps (object, properties) {
  let props = {}
  properties.forEach((prop) => {
    props[prop] = {
      get () {
        return this[object] && this[object][prop]
      },
      set (newValue) {
        this[setterFor(prop)](newValue)
      }
    }
  })
  return props
}

export function mapObjectMutations (keyPath, props) {
  return props
    .reduce((acc, key) => {
      acc[setterFor(key)] = (state, value) => {
        Vue.set(_.get(state, keyPath), key, value)
      }
      return acc
    }, {})
}

export function mapEmitProps (properties) {
  let props = {}
  properties.forEach((prop) => {
    props[prop] = {
      get () { return this.value && this.value[prop] },
      set (newValue) {
        this.$emit('input', {
          ...this.value,
          [prop]: newValue
        })
      }
    }
  })

  return props
}

export function mapEmitProp (property) {
  return {
    property: {
      get () { return this.value && this.value[property] },
      set (newValue) {
        this.$emit('input', {
          ...this.value,
          [property]: newValue
        })
      }
    }
  }
}

export function hasClass (obj, cls) {
  return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

export function addClass (obj, cls) {
  if (!hasClass(obj, cls)) obj.className += ' ' + cls
}

export function removeClass (obj, cls) {
  if (hasClass(obj, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    obj.className = obj.className.replace(reg, ' ')
  }
}

export function toggleClass (obj, cls) {
  if (hasClass(obj, cls)) {
    removeClass(obj, cls)
  } else {
    addClass(obj, cls)
  }
}

export function extractNetworkError (error) {
  const data = _.get(error, 'response.data')
  if (data) {
    if (data.length > 0) {
      return error.response.data[0]
    } else if (typeof data === 'object') {
      const errors = Object.values(data)
      const error = _.get(errors, '[0][0]')
      return error && { description: error }
    }
  }

  return null
}

export function extractNetworkErrorMessage (error) {
  const networkError = extractNetworkError(error)
  if (networkError == null &&
      error &&
      error.response &&
      error.response.status >= 400) {
    return i18n.t('messages:errorOccuredMessage')
  }
  if (error.code === 'ECONNABORTED') { // request timeout
    return i18n.t('messages:errorOccuredMessage')
  }
  return networkError && networkError.description
}

export function guid () {
  var d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += window.performance.now() // use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}

export function dataURItoBlob (dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  let byteString = window.atob(dataURI.split(',')[1])
  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length)
  var ia = new Uint8Array(ab)
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  // write the ArrayBuffer to a blob, and you're done
  var blob = new window.Blob([ab], { type: mimeString })
  return blob
}

export function hashCode (stringOrObject) {
  if (typeof stringOrObject === 'object') {
    stringOrObject = JSON.stringify(stringOrObject)
  }
  let hash = 0
  let i
  let chr
  let len

  if (stringOrObject.length === 0) return hash
  for (i = 0, len = stringOrObject.length; i < len; i++) {
    chr = stringOrObject.charCodeAt(i)
    hash = ((hash << 5) - hash) + chr
    hash |= 0 // Convert to 32bit integer
  }
  return hash
}

export function getImageSize (file) {
  return new Promise(function (resolve) {
    const reader = new window.FileReader()
    const useBlob = false && window.URL
    reader.addEventListener('load', function () {
      const image = new window.Image()
      image.addEventListener('load', function () {
        resolve({
          width: image.width,
          height: image.height
        })
        if (useBlob) {
          // Free some memory for optimal performance
          window.URL.revokeObjectURL(image.src)
        }
      })
      image.src = useBlob ? window.URL.createObjectURL(file) : reader.result
    })
    reader.readAsDataURL(file)
  })
}

export const isProd = process.env.NODE_ENV === 'production'




// WEBPACK FOOTER //
// ./src/utils/index.js